import React, { Component } from "react";
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Actions, { thunks } from '../../redux/modules/offers';

class OfferModal extends Component {

    componentDidMount(){
        this.props.dispatch(thunks.getOffer());
    }

    selectOffer = offer => {
        this.props.onSelect(offer);
    }
   
    render() {
        const {
            show,
            onHide,
            list,
        } = this.props;
        return (
            <Modal
                show={show}
                onHide={onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Offers
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                           <div className="col-md-12">
                            <div className="table-responsive">
                            <table className="table table-bordered pt-2">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                        <th scope="col">Offer Description</th>
                                        <th scope="col">Image</th>
                                        <th scope="col">Image Description</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            {list.length ? (
                                list.map(offer => (
                                    <tr key={offer.id}>
                                        <th>{offer.id}</th>
                                            <td>{offer.offerDescription}</td>
                                            <td>
                                                <td>
                                                    {offer.imageId ? <img src={offer.imageId} alt="image" width="80px" /> : '-'}
                                                </td>
                                            </td>
                                            <td>{offer.imageDescription}</td>
                                        <td>
                                            <button title="View User" className="btn btn-xs btn-info ml-2" onClick={() => this.selectOffer(offer)}>
                                                <i className="fa fa-plus" />
                                            </button> </td>
                                    </tr>)))
                                : (
                                    <tr>
                                        <td colSpan="8" className="text-center">No Records Found</td>
                                    </tr>
                                )}
                        </table>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        )
    }

}
const mapStateToProps = ({
    offers: {
        list,
        message,
    },
}) => ({
    list,
    message,
});
const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
    reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(OfferModal)